;
export var JoinPlane;
(function (JoinPlane) {
    JoinPlane[JoinPlane["Left"] = 0] = "Left";
    JoinPlane[JoinPlane["Right"] = 1] = "Right";
    JoinPlane[JoinPlane["Top"] = 2] = "Top";
    JoinPlane[JoinPlane["Bottom"] = 3] = "Bottom";
})(JoinPlane || (JoinPlane = {}));
export var JoinType;
(function (JoinType) {
    JoinType[JoinType["Start"] = 0] = "Start";
    JoinType[JoinType["End"] = 1] = "End";
})(JoinType || (JoinType = {}));
export var JoinVariant;
(function (JoinVariant) {
    JoinVariant[JoinVariant["Angle"] = 0] = "Angle";
    JoinVariant[JoinVariant["GashAndAngle"] = 1] = "GashAndAngle";
    JoinVariant[JoinVariant["Horizontal"] = 2] = "Horizontal";
    JoinVariant[JoinVariant["Vertical"] = 3] = "Vertical";
    JoinVariant[JoinVariant["DoubleAngle"] = 4] = "DoubleAngle";
    JoinVariant[JoinVariant["MirrorAngle"] = 5] = "MirrorAngle";
    JoinVariant[JoinVariant["Decorative"] = 6] = "Decorative";
})(JoinVariant || (JoinVariant = {}));
export var DiagonalVariantCalc;
(function (DiagonalVariantCalc) {
    DiagonalVariantCalc[DiagonalVariantCalc["Bottom"] = 0] = "Bottom";
    DiagonalVariantCalc[DiagonalVariantCalc["Top"] = 1] = "Top";
    DiagonalVariantCalc[DiagonalVariantCalc["Center"] = 2] = "Center";
    DiagonalVariantCalc[DiagonalVariantCalc["Oblique"] = 3] = "Oblique";
})(DiagonalVariantCalc || (DiagonalVariantCalc = {}));
export var DirectionVec;
(function (DirectionVec) {
    DirectionVec[DirectionVec["Up"] = 0] = "Up";
    DirectionVec[DirectionVec["Down"] = 1] = "Down";
})(DirectionVec || (DirectionVec = {}));
export var PositionVec;
(function (PositionVec) {
    PositionVec[PositionVec["Up"] = 0] = "Up";
    PositionVec[PositionVec["Center"] = 1] = "Center";
    PositionVec[PositionVec["Down"] = 2] = "Down";
})(PositionVec || (PositionVec = {}));
export var DecorativeJoinType;
(function (DecorativeJoinType) {
    DecorativeJoinType[DecorativeJoinType["corner"] = 0] = "corner";
    DecorativeJoinType[DecorativeJoinType["angle"] = 1] = "angle";
    DecorativeJoinType[DecorativeJoinType["stepped"] = 2] = "stepped";
    DecorativeJoinType[DecorativeJoinType["curve"] = 3] = "curve";
    DecorativeJoinType[DecorativeJoinType["curveIndent"] = 4] = "curveIndent";
    DecorativeJoinType[DecorativeJoinType["curveS"] = 5] = "curveS";
})(DecorativeJoinType || (DecorativeJoinType = {}));
export function getInitParam() {
    return {
        a: 20,
        sizes: { h: 0, l: 0, w: 0 },
        maxSize: { a: 35, h: 0, l: 0, w: 0 },
        minSize: { a: 12, h: 0, l: 0, w: 0 },
        setting: {},
        gash: {},
        angles: {},
        elementData: {},
        map: []
    };
}
